//序列号详情
<template>
  <div id="serialDetaials">
    <!-- 搜索框 -->
    <div class="search_aera">
      <el-input
        placeholder="请输入搜索内容"
        size="mini"
        v-model="dest"
        @keyup.enter="getDetailsListAction({ orderId, options })"
      >
        <el-button
          slot="append"
          size="mini"
          type="primary"
          icon="el-icon-search"
          :disabled="dest.trim() == ''"
          @click="getDetailsListAction({ orderId, options })"
          title="搜索"
        ></el-button>
      </el-input>
      <span class="item" v-if="getEscSearchIcon" @click="escSearch()">退出搜索</span>
    </div>
    <el-table :data="getDetailsList" border ref="auth" style="width: 100%" @sort-change="emitSort">
      <el-table-column prop="number" label="序列号" align="center" sortable="custom" width="250"></el-table-column>
      <el-table-column prop="product_ver" align="center" sortable="custom" label="产品版本"></el-table-column>
      <el-table-column prop="status" align="center" sortable="custom" label="激活状态"></el-table-column>
      <el-table-column prop="active_num" align="center" sortable="custom" label="激活次数"></el-table-column>
      <el-table-column prop="first_active_date" align="center" sortable="custom" label="初次激活"></el-table-column>
      <el-table-column prop="last_active_date" align="center" sortable="custom" label="最近激活"></el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="allList"
      :background="true"
      layout="total, prev, pager, next, jumper"
      prev-text="上一页"
      next-text="下一页"
      @current-change="currentPageChange"
    ></el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "pcib-order-serial-details",
  data() {
    return {
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页面
      parmas: {}, // 排序信息
      dest: ""
    };
  },
  computed: {
    orderId() {
      return this.$route.params.order_id;
    },
    allList() {
      return this.getDetailsListCount;
    },
    options() {
      let sort = this.parmas.order
        ? this.parmas.order === "ascending"
          ? this.parmas.prop
          : "-" + this.parmas.prop
        : "";
      return {
        limit: 10,
        offset: (this.currentPage - 1) * 10,
        sort: sort,
        dest: this.dest
      };
    },
    ...mapGetters("config", {
      getDetailsList: "getDetailsList",
      getDetailsListCount: "getDetailsListCount",
      getEscSearchIcon: "getEscSearchIcon"
    })
  },
  methods: {
    currentPageChange(index) {
      this.currentPage = index;
      this.getDetailsListAction({
        orderId: this.orderId,
        options: this.options
      });
    },
    emitSort(args) {
      this.parmas = args;
      this.getDetailsListAction({
        orderId: this.orderId,
        options: this.options
      });
    },
    escSearch() {
      this.dest = "";
      this.getDetailsListAction({
        orderId: this.orderId,
        options: this.options
      });
    },
    ...mapActions("config", {
      getDetailsListAction: "getDetailsListAction"
    })
  },
  created() {
    this.$parent.url = this.url;
    this.getDetailsListAction({
      orderId: this.orderId,
      options: this.options
    });
  }
};
</script>

<!-- 组件的样式不复用 -->
<style scoped lang="scss">
@import "~@/style/base/constant";
@import "~@/style/components/serial_details";
</style>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderSerialDetails.vue